import { LoadingFinanceSimulationContent } from '~/components/molecules/LoadingFinanceSimulationContent'
import { SpinnerLoading } from '~/styles/global'
import { useLoadingCPFAnalysis } from './hooks'

export const LoadingCPFAnalysis = () => {
  const { loadingDescription } = useLoadingCPFAnalysis()

  return <LoadingFinanceSimulationContent text={loadingDescription} icon={<SpinnerLoading />} />
}
